export default "__VITE_ASSET__DAEBk$Fb__"